import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import { Redirect, Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import profileEggsSpec from "../../../assets/img/avatars/8.jpg";
import CompanyAdd from "../../Forms/Comany/CompanyAdd/AddCompany";
// import { IdleTimeOutHandler } from "../../IdleTimeOutHandler";
import IdleTimeOutHandler from "../../IdleTimeOutHandler";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  FormGroup,
} from "reactstrap";
import backgroundPic from "./../../../assets/img/dashLogo.png";
// import complogo from "./../../../../../node_backendAS/uploads/CompanyLogo/A_2022_4_15_21_26_34537630215";
import { baseurl } from "../../../baseurl";
import { Modal } from "react-bootstrap";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
import axios from "axios";
import "./myindex.css";
import UserChangePassword from "../../Forms/ShortCutComponents/UserChangePassword";
import { conditionalCallBlocking } from "../../Forms/ShortFunction/shortFunctions";

const isCallBlocked = conditionalCallBlocking();

var thisContex;
var token = localStorage.getItem("token");
var userName = localStorage.getItem("username");
// const divStyle = {
//   backgroundImage: `url(${backgroundPic})`,
//   backgroundSize: "220px 100px",
//   // backgroundColor: "#63c2de",
//   backgroundRepeat: "no-repeat",
// };
const textStyle = {
  fontFamily: "Times New Roman",
  textAlign: "center",
};
const backgroundColor = {
  // backgroundColor: "#405359",
};
window.addEventListener("load", function () {
  setTimeout(function () {
    // This hides the address bar:
    window.scrollTo(0, 1);
  }, 0);
});
document.addEventListener("contextmenu", (e) => e.preventDefault());
// function ctrlShiftKey(e, keyCode) {
//   return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
// }
// document.onkeydown = (e) => {
//   console.log(e.keyCode);

//   // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
//   if (
//     e.keyCode === 116 ||
//     ctrlShiftKey(e, "R")
//     // ctrlShiftKey(e, "J") ||
//     // ctrlShiftKey(e, "C") ||
//     // (e.ctrlKey && e.keyCode === "U".charCodeAt(0))
//   )
//     return false;
// };
const handleSubmit = (e) => {
  e.preventDefault();
  var token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const {
    companyName,
    address1,
    address2,
    saleTaxApply,
    saleTaxNo,
    phoneNo,
    companyNo,
    email,
    currencyID,
  } = thisContex.state;

  console.log(companyName);
  console.log(address1);
  console.log(address2);
  console.log(saleTaxApply);
  console.log(saleTaxNo);
  console.log(phoneNo);
  console.log(companyNo);
  console.log(email);
  console.log(currencyID);

  axios
    .post(`${baseurl}/auth/getAddCompany`, {
      companyName: companyName,
      address1: address1,
      address2: address2,
      saleTaxApply: saleTaxApply,
      saleTaxNo: saleTaxNo,
      phoneNo: phoneNo,
      companyNo: companyNo,
      email: email,
      currencyID: currencyID,
      username: username,
    })
    .then(function (response) {
      console.log(response);

      swal({
        title: "Saved Successfully!",
        text: "Employee Add",
        icon: "success",
      }).then((value) => {
        window.location.reload();
        // thisContex.getData();
        // thisContex.addToggle();
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

class Login extends Component {
  constructor(props) {
    super(props);
    console.log("props fff", props);
    this.state = {
      username: "",
      password: "",
      passwordType: "password",
      newPasswordType: "password",
      confirmPasswordType: "password",
      postingError: false,
      showModal: false,
      showModalCompany: false,
      enterEmail: "",
      loaderMsg: false,
      invalidPswrd: false,
      userStatus: false,
      passwordError: "",
      newPassword: "",
      showChangePasswordModal: false,
      confirmPassword: "",
      dataLoader: false,
      showForgetModal: false,
      showPasswordModal: false,
      disabled: false,
      companyData: [],
      isLoaderResponse: false,
      loginId: "",
      spanError: "",
      postingErrorMsg: "Wrong credentials. Try again",
      incorrectEmail: false,
      loggedIn: false,
      loader: false,
      isErrorCheck: false,
      responseErrorMsg: "",
    };

    this.toggle = this.toggle.bind(this);
    this.toggleCode = this.toggleCode.bind(this);
    this.resetChildStates = this.resetChildStates.bind(this);
    //this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addToggleCompany = this.addToggleCompany.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeConfirmPassword =
      this.handleChangeConfirmPassword.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitEmail = this.submitEmail.bind(this);
    this.submitNewPassword = this.submitNewPassword.bind(this);
    this.submitCodeForm = this.submitCodeForm.bind(this);
    this.resendCode = this.resendCode.bind(this);
    // this.matchPassword = this.matchPassword.bind(this);
    //this.selectCompany = this.selectCompany.bind(this);
    thisContex = this;
  }
  handleChange = (e) => {
    this.state.confirmPassword &&
      this.matchPassword(e.target.value, this.state.confirmPassword);

    this.setState({
      [e.target.name]: e.target.value,
      incorrectEmail: false,
    });
  };
  handleChangetypeLov = (e) => {
    if (e.target.name === "currencyID") {
      thisContex.setState({
        currencyID: e.target.value,
      });
    }
  };
  handleChangeCompany(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  handleChangeConfirmPassword = (e) => {
    let newPass = this.state.newPassword;
    let confirmPass = e.target.value;

    this.setState({
      [e.target.name]: e.target.value,
    });

    newPass && this.matchPassword(newPass, confirmPass);
    // if (e.target.value !== newPassword) {
    //   this.setState({
    //     passwordError: "Password Must Match",
    //     disabled: true,
    //   });
    // } else {
    //   this.setState({
    //     passwordError: "",
    //     disabled: false,
    //   });
    // }
  };
  matchPassword = (newPass, confirmPass) => {
    console.log("newPass:", newPass);
    console.log("confirmPass:", confirmPass);
    if (newPass !== confirmPass || confirmPass !== newPass) {
      this.setState({
        passwordError: "Password Must Match",
        disabled: true,
      });
    } else {
      this.setState({
        passwordError: "",
        disabled: false,
      });
    }
  };
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      spanError: "",
      postingErrorMsg: false,
    });
  }

  resendCode(e) {
    e.preventDefault();
    const { username, code, spanError, enterEmail } = this.state;
    console.log("username.....", username);
    var randomCode = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 5; i++) {
      randomCode += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    var token = localStorage.getItem("token");
    axios
      .post(`${baseurl}/forgetPass/resendCode`, {
        username: enterEmail,
      })
      .then((response) => {
        response.data.message === "Email sent" &&
          thisContex.setState({ code: "", spanError: "" });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  submitCodeForm(e) {
    e.preventDefault();
    const { code, loginId, enterEmail, username } = this.state;
    // var username = localStorage.getItem("username");
    var token = localStorage.getItem("token");
    axios
      .post(`${baseurl}/forgetPass/checkCodeMatchLogin`, {
        enterCode: code,
        insertedId: loginId,
        enterEmail: enterEmail,
        username: username,
      })
      .then((response) => {
        if (
          response.data.message === "Success" &&
          response.data.insertedId !== ""
        ) {
          swal({
            title: "Code Verification",
            text: "Code is mached ",
            icon: "success",
          }).then((value) => {
            thisContex.GetCompanies();

            // axios
            //   .post(
            //     `${baseurl}/masterData/getCompany`,
            //     { username: username },
            //     {
            //       headers: {
            //         authorization: token,
            //       },
            //     }
            //   )
            //   .then((response) => {
            //     var dataLength = response.data.data.length;

            //     if (dataLength > 1) {
            //       this.toggle();
            //       this.setState({
            //         companyData: response.data.data,

            //         isLoaderResponse: true,
            //       });
            //     } else {
            //       var companyId = response.data.data[0]["COMPANY_ID"];
            //       var companyName = response.data.data[0]["COMPANY_DESC"];

            //       var companylog = response.data.data[0]["COMPANY_SYMBOL"];
            //       console.log("image,,,,,", companylog);
            //       var companyFinancialDate =
            //         response.data.data[0]["COMPANY_DATE"];
            //       var companySymbolCurrency =
            //         response.data.data[0]["CURRENCY_SYMBOL"];
            //       var currencyId = response.data.data[0]["currency_id"];

            //       localStorage.setItem("companyId", companyId);
            //       localStorage.setItem("companyName", companyName);
            //       localStorage.setItem("companylog", companylog);
            //       localStorage.setItem("currencyId", currencyId);
            //       localStorage.setItem(
            //         "companyFinancialDate",
            //         companyFinancialDate
            //       );
            //       localStorage.setItem(
            //         "companySymbolCurrency",
            //         companySymbolCurrency
            //       );
            //       this.setState({
            //         loggedIn: true,
            //         loginId: response.data.sysUserId,
            //         spanError: "",
            //       });
            //     }
            //   });
          });
        } else if (
          response.data.message === "Success" &&
          response.data.insertedId === ""
        ) {
          thisContex.setState({ showPasswordModal: true });
          this.toggleCode();
        } else {
          this.setState({
            spanError: "Please Enter Correct Code",
          });
        }
      });
  }
  feedbackLogin = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    console.log(username);
    console.log(password);
    this.setState({
      dataLoader: true,
    });
    setTimeout(() => {
      // console.log('User has been successfully saved!', values)
      this.setState({ loaderMsg: true });
    }, 6000);

    axios
      .post(`${baseurl}/auth/loginEggs`, {
        username: username,
        password: password,
      })
      .then((response) => {
        let data = response.data;
        console.log("data", data);
        if (
          username == "admin@gmail.com" ||
          username.split("_")[0] === "eggs"
        ) {
          console.clear();
          localStorage.setItem("username", response?.data?.username);
          localStorage.setItem("branchId", response?.data?.branch_id);
          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem("firstName", "EggsSpectations");
          localStorage.setItem("profile_pic", null);
          localStorage.setItem("counter", 0);
          localStorage.setItem("db_check", false);
          this.props.history.push("/Dashboard");
          // return <. to="/AdminSuppDashboard" />;
        } else {
          let companyId = response.data?.companyId;
          thisContex.setState({
            loginInfo: data,
            loaderMsg: false,
            userEmail: username,
          });
          // ------------------ Check Email or Password here-----------------
          if (data?.message === "Auth Successfull") {
            let user = response.data.username;
            let codeEnterYn = response.data.codeEnterYn;
            localStorage.clear();
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("db_check", false);
            // localStorage.setItem("employeeId", response.data.sysUserId);
            localStorage.setItem("username", response?.data?.username);
            // localStorage.setItem("firstName", response.data.firstName);
            localStorage.setItem("profile_pic", { profileEggsSpec });
            // localStorage.setItem("counter", 0);
            // localStorage.setItem("Title");
            // console.log(data);
            if (data?.sysUser == 1) {
              console.log('data.sysUser "App user " :>> ', data.sysUser);
              if (data?.appUserPassUpdate == 0) {
                this.setState({
                  showChangePasswordModal: true,
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });
              } else {
                console.log('data.sysUser "System user " :>> ', data.sysUser);
                this.setState({
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });

                // this.GetCompanies();
                // this.idleTime();
              }
              // this.GetCompanies();
            } else {
              if (codeEnterYn == "0") {
                this.toggleCode();
                this.setState({
                  loginId: response.data.sysUserId,
                  dataLoader: false,
                  user,
                });
              } else {
                console.log('data.sysUser "System user " :>> ', data.sysUser);
                this.setState({
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });

                // this.GetCompanies();
              }

              // this.idleTime();
            }

            //;
          }
          if (response.data.message === "Code Not Enter") {
            this.toggleCode();
            this.setState({
              loginId: response.data.sysUserId,
              dataLoader: false,
            });
          }
          // if (response.data.message === "Auth faild") {
          //   //this.toggleCode();
          //   this.setState({
          //     postingError: true,
          //     dataLoader: false,
          //   });
          // }
        }
      })
      .catch((err) => {
        this.setState({
          invalidPswrd: true,
        });
        this.setState({ postingError: true, dataLoader: false });
        console.log(err);
      });
  };
  submitForm(e) {
    e.preventDefault();
    const { username, password } = this.state;
    console.log(username);
    console.log(password);

    this.setState({
      dataLoader: true,
      userStatus: false,
    });
    setTimeout(() => {
      // console.log('User has been successfully saved!', values)
      this.setState({ loaderMsg: true });
    }, 6000);

    axios
      .post(`${baseurl}/auth/login`, {
        username: username,
        password: password,
      })
      .then((response) => {
        let data = response.data;
        console.log("data.LAST_NAME== ", data.LAST_NAME);
        localStorage.setItem("emp_last_name", data.LAST_NAME);
        if (username == "admin@accmen.net") {
           localStorage.setItem("token", response.data.token);
          this.props.history.push("/AdminSuppDashboard");
          // return <Redirect to="/AdminSuppDashboard" />;
        } else if (
          username == "admin@gmail.com" ||
          username.split("_")[0] === "eggs"
        ) {
          this.props.history.push("/FeedBackEggSpectation");
          // return <Redirect to="/AdminSuppDashboard" />;
        } else {
          let companyId = response.data?.companyId;
          thisContex.setState({
            loginInfo: data,
            loaderMsg: false,
            userEmail: username,
          });
console.log(response.data);
          if (username.split("_")[0] !== "SJM") {
            if (!data.active_yn) {
              thisContex.setState({
                userStatus: true,
                dataLoader: false,
              });
              return
            }
          }

          // ------------------ Check Email or Password here-----------------
          if (data?.message === "Auth Successfull") {
            let user = response.data.username;
            let codeEnterYn = response.data.codeEnterYn;
            // localStorage.setItem("token", response.data.token);
            // localStorage.setItem("employeeId", response.data.sysUserId);
            // localStorage.setItem("username", response?.data?.username);
            // localStorage.setItem("firstName", response.data.firstName);
            // localStorage.setItem("profile_pic", response.data.profile_pic);
            // localStorage.setItem("counter", 0);
            // localStorage.setItem("Title");
            // console.log(data);
            if (data?.sysUser == 1) {
              console.log('data.sysUser "App user " :>> ', data.sysUser);
              if (data?.appUserPassUpdate == 0) {
                this.setState({
                  showChangePasswordModal: true,
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });
              } else {
                console.log('data.sysUser "System user " :>> ', data.sysUser);
                this.setState({
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });

                this.GetCompanies();
                // this.idleTime();
              }
              // this.GetCompanies();
            } else {
              if (codeEnterYn == "0") {
                this.toggleCode();
                this.setState({
                  loginId: response.data.sysUserId,
                  dataLoader: false,
                  user,
                });
              } else {
                console.log('data.sysUser "System user " :>> ', data.sysUser);
                this.setState({
                  dataLoader: false,
                  spanError: "",
                  user,
                  loginData: data,
                });

                this.GetCompanies();
              }

              // this.idleTime();
            }

            //;
          }
          if (response.data.message === "Code Not Enter") {
            this.toggleCode();
            this.setState({
              loginId: response.data.sysUserId,
              dataLoader: false,
            });
          }
          // if (response.data.message === "Auth faild") {
          //   //this.toggleCode();
          //   this.setState({
          //     postingError: true,
          //     dataLoader: false,
          //   });
          // }
        }
      })
      .catch((err) => {
        console.log("err.response?.data?.code", err.response?.data?.code);
        console.log("err.response?.data?.message", err.response?.data?.message);

        // Check for PAYMENT_PENDING error code
        const isPaymentPending = err.response?.data?.code === "PAYMENT_PENDING";
        const errorMessage = err.response?.data?.message || "Wrong credentials. Try again";

        // Show swal for PAYMENT_PENDING error
        if (isPaymentPending) {
          swal({
            title: "Account Restricted",
            text: errorMessage,
            icon: "warning",
            button: "OK",
          });
        } else {
          // alert("Wrong credentials. Try again");
        }

        this.setState({
          invalidPswrd: !isPaymentPending, // Only show invalid password for non-payment errors
          isErrorCheck: isPaymentPending,
          responseErrorMsg: errorMessage,
        });
        this.setState({ postingError: true, dataLoader: false });
        console.log(err);
      });
  }
  componentDidMount() {
    // this.getDataLoad();
    // localStorage.setItem("block", "");
  }

  ////////////////-----Show Table LOV and Data------////////////////////
  getDataLoad() {
    var token = localStorage.getItem("token");
    var username = localStorage.getItem("username");
    axios
      .post(`${baseurl}/auth/getCurrency`, { username: username })
      .then(function (response) {
        thisContex.setState({
          currencyLov: response.data.data,
          isLoadedlovCurrency: true,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  // this  fun is use d for refresh th states
  resetChildStates = () => {
    this.setState({
      code: "",
      enterEmail: "",
      confirmPassword: "",
      passwordError: "",
      newPassword: "",
      spanError: "",
      incorrectEmail: "",
    });
  };
  appUserLoginWithCompanyId = (data) => {
    const { companyId, username } = data;
    const { loginInfo } = this.state;
    // return
    axios
      .post(
        `${baseurl}/auth/getCompanyDataWithId`,
        { id: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        console.log(response.data.data);
        console.log("response.data.data :>> ", response.data.data);
        let companyId = response.data.data[0]?.COMPANY_ID,
          companyName = response.data.data[0]?.COMPANY_DESC,
          companylog = response.data.data[0]?.COMPANY_SYMBOL,
          companyFinancialDate = response.data.data[0]?.COMPANY_DATE,
          comp_lang = response.data.data[0]?.comp_lang,
          currencyId = response.data.data[0]?.currency_id;
        {
          if (localStorage.getItem("comp_lang") == "ur") {
            localStorage.setItem("select", "--منتخب کریں--");
          } else if (localStorage.getItem("comp_lang") == "ar") {
            localStorage.setItem("select", "--يختار--");
          } else {
            localStorage.setItem("select", "select");
          }
        }
        localStorage.setItem("token", loginInfo.token);
        localStorage.setItem("db_check", loginInfo.db_check);
        localStorage.setItem("employeeId", loginInfo.sysUserId);
        localStorage.setItem("username", loginInfo.username);
        localStorage.setItem("firstName", loginInfo.firstName);
        localStorage.setItem("profile_pic", loginInfo.profile_pic);
        localStorage.setItem("SystemUser", loginInfo.sysUser);
        localStorage.setItem("counter", 0);
        localStorage.setItem("companyId", companyId);
        localStorage.setItem("companyName", companyName);
        localStorage.setItem("companyFinancialDate", companyFinancialDate);
        localStorage.setItem("companylog", companylog);
        localStorage.setItem("currencyId", currencyId);
        localStorage.setItem("comp_lang", comp_lang);
        {
          if (comp_lang == "ur") {
            localStorage.setItem("select", "منتخب");
          } else if (comp_lang == "ar") {
            localStorage.setItem("select", "تحديد");
          } else if (comp_lang == "en") {
            localStorage.setItem("select", "select");
          }
        }
        thisContex.setState({
          loggedIn: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  submitEmail(e) {
    e.preventDefault();
    const { enterEmail } = this.state;
    thisContex.setState({
      loader: true,
    });

    var randomCode = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < 5; i++) {
      randomCode += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    var token = localStorage.getItem("token");
    var username = localStorage.getItem("username");

    axios
      .post(
        `${baseurl}/auth/${enterEmail === "admin@gmail.com" ||
          enterEmail.split("_")[0] === "eggs"
          ? "emailForgetPasswordEggs"
          : "emailForgetPassword"
        }`,
        {
          enterEmail: enterEmail,
          username: enterEmail,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        if (response.data.message === "Email sent") {
          this.setState({
            showCodeModal: true,
            showForgetModal: false,
            loader: false,
          });
        } else {
          this.setState({
            spanError: "Please Enter Correct Code",
            loader: false,
          });
        }
      })
      .catch((err) => {
        this.setState({ incorrectEmail: true, loader: false });
        console.log(err);
      });
  }

  submitNewPassword(e) {
    e.preventDefault();
    const { enterEmail, confirmPassword } = this.state;

    var token = localStorage.getItem("token");
    var username = localStorage.getItem("username");

    axios
      .post(
        `${baseurl}/auth/submitNewPassword`,
        {
          confirmPassword: confirmPassword,

          username: enterEmail,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        if (response.data.message === "Success") {
          window.location.reload();
        } else {
          this.setState({
            spanError: "Please Enter Correct Code",
          });
        }
      })
      .catch((err) => {
        this.setState({ postingError: true });
        console.log(err);
      });
  }
  selectCompany = (
    companyId,
    companyName,
    companylog,
    currencyId,
    companySymbolCurr,
    companyFinancialDate,
    depMethod,
    yearMonth,
    comp_lang
  ) => {
    const { loginData } = this.state;
    console.clear();
    console.log("loginData :>> ", loginData);
    localStorage.setItem("token", loginData?.token);
    localStorage.setItem("employeeId", loginData?.sysUserId);
    localStorage.setItem("db_check", loginData?.db_check);
    localStorage.setItem("username", loginData?.username);
    localStorage.setItem("firstName", loginData?.firstName);
    localStorage.setItem("profile_pic", loginData?.profile_pic);
    localStorage.setItem("counter", 0);
    // localStorage.setItem("Title");
    localStorage.setItem("companyId", companyId);
    localStorage.setItem("companyName", companyName);
    localStorage.setItem("companylog", companylog);
    localStorage.setItem("currencyId", currencyId);
    localStorage.setItem("companyFinancialDate", companyFinancialDate);
    localStorage.setItem("depMethod", depMethod);
    localStorage.setItem("yearMonth", yearMonth);
    localStorage.setItem("comp_lang", comp_lang);

    {
      if (comp_lang == "ur") {
        localStorage.setItem("select", "منتخب");
      } else if (comp_lang == "ar") {
        localStorage.setItem("select", "تحديد");
      } else if (comp_lang == "en") {
        localStorage.setItem("select", "select");
      }
    }
    var companySymbolCurrency = companySymbolCurr;

    console.log(companylog);
    localStorage.setItem("companySymbolCurrency", companySymbolCurrency);

    this.setState({
      loggedIn: true,
    });
  };

  addToggleCompany = () => {
    // this.setState({
    // itemTypeName: "",
    // });
    thisContex.toggleAddNew();
    // this.getDataLoad();
  };

  toggle = () => {
    this.setState({ showModal: !this.state.showModal });
  };
  passwordModalToggle = () => {
    this.setState({
      showChangePasswordModal: !this.state.showChangePasswordModal,
    });
  };
  GetCompanies = () => {
    var token = localStorage.getItem("token");
    let user = thisContex.state.user;
    var username = user ? user : localStorage.getItem("username");
    axios
      .post(`${baseurl}/auth/getCompany`, {
        username: username,
      })
      .then((response) => {
        var dataLength = response.data.data.length;
        if (dataLength > 1) {
          thisContex.toggle();
          thisContex.setState({
            companyData: response.data.data,

            isLoaderResponse: true,
          });
        } else if (dataLength === 1) {
          var companyId = response.data.data[0]?.COMPANY_ID;

          var companyName = response.data.data[0]?.COMPANY_DESC;
          var companylog = response.data.data[0]?.COMPANY_SYMBOL;
          var companyFinancialDate = response.data.data[0]?.COMPANY_DATE;

          var currencyId = response.data.data[0]?.currency_id;
          var comp_lang = response.data.data[0]?.comp_lang;
          const { loginData } = this.state;
          console.log("loginData", loginData);

          localStorage.setItem("token", loginData?.token);
          localStorage.setItem("employeeId", loginData?.sysUserId);
          localStorage.setItem("db_check", loginData?.db_check);
          localStorage.setItem("username", loginData?.username);
          localStorage.setItem("firstName", loginData?.firstName);
          localStorage.setItem("profile_pic", loginData?.profile_pic);
          localStorage.setItem("counter", 0);
          localStorage.setItem("page_size", 50);
          localStorage.setItem("companyId", companyId);
          localStorage.setItem("companyName", companyName);
          localStorage.setItem("companyFinancialDate", companyFinancialDate);
          localStorage.setItem("companylog", companylog);
          localStorage.setItem("currencyId", currencyId);
          localStorage.setItem("comp_lang", comp_lang);
          localStorage.setItem(
            "companySymbolCurrency",
            response.data.data[0]?.CURRENCY_SYMBOL
          );
          {
            if (comp_lang == "ur") {
              localStorage.setItem("select", "منتخب");
            } else if (comp_lang == "ar") {
              localStorage.setItem("select", "تحديد");
            } else if (comp_lang == "en") {
              localStorage.setItem("select", "select");
            }
          }
          this.setState({
            loggedIn: true,
            loginId: response.data.sysUserId,
          });
        } else {
          swal({
            title: "No Company is available",
            text: "Create a company to continue",
            icon: "error",
          });
          thisContex.addToggleCompany();
        }
      });
  };
  // idleTime() {
  //   return (
  //     <IdleTimeOutHandler
  //       onActive={() => {
  //         this.setState({
  //           setIsActive: true,
  //         });
  //       }}
  //       onIdle={() => {
  //         this.setState({
  //           setIsActive: false,
  //         });
  //       }}
  //       onLogout={() => {
  //         window.location.href = "/";
  //         localStorage.setItem("token", null);
  //       }}
  //       refresh={() => this.state.loggedIn++}
  //     />
  //   );
  // }
  toggleAddNew = () => {
    this.setState({ showModalCompany: !this.state.showModalCompany });
    if (this.state.showModalCompany === false) this.GetCompanies();
  };
  toggleCode = () => {
    this.setState({
      showCodeModal: !this.state.showCodeModal,
      //showCodeModal: false,
    });
  };
  toggleNewPaswrd = () => {
    // showCodeModal: false,
    this.setState({
      showPasswordModal: !this.state.showPasswordModal,
      showCodeModal: false,
    });
  };
  addToggle = () => {
    this.setState({ showForgetModal: !this.state.showForgetModal });
    this.resetChildStates();
  };
  GetCompanyLogo = (imgName) =>
    `${baseurl}/getImages/companyLogoImg/?fileName=${imgName}`;

  render() {
    const {
      companyName,
      img,
      address1,
      address2,
      saleTaxApply,
      saleTaxNo,
      phoneNo,
      companyNo,
      email,
      currencyID,
      loginData,
      isLoadedlovCurrency,
      currencyLov,
      showChangePasswordModal,
      loader,
      loggedIn,
      loaderMsg,
    } = this.state;

    if (loggedIn) {
      console.log("loggedIn :>> ", loggedIn);
      // this.state.username;
      if (
        this.state.username === "admin@gmail.com" ||
        this.state.username.split("_")[0] === "eggs"
      ) {
        return <Redirect to="/FeedBackEggSpectation" />;
      } else if (this.state.username === "SJM_Admin@gmail.com") {
        return <Redirect to="/RFQOv" />;
      } else if (this.state.username.split("_")[0] === "SJM") {
        return <Redirect to="/TranportersDash" />;
      } else {
        return <Redirect to="/Home" />;
      }
    }
    if (this.state.dataLoader === true) {
      return (
        <ResponseLoader
          data={
            loaderMsg
              ? "Creating DataBase...Do Not Refresh the page.This is one Time Process"
              : "Logging In ..."
          }
        />
      );
    }
    return (
      <>
        <div
          className="app flex-row align-items-center loginbody"
        //  style={backgroundColor}
        >
          <div> </div>
          <Container>
            <Row className="justify-content-center pb-5">
              <img src={backgroundPic} alt="Logo" width="220" height="130%" />
              {/* NAYYER INDUSTRIES SYSTEM*/}
            </Row>
            <Row className="justify-content-center">
              <Col md="8">
                <CardGroup>
                  <Card className="p-4">
                    <CardBody>
                      <Form
                        onSubmit={
                          this.state.username === "admin@gmail.com" ||
                            this.state.username.split("_")[0] === "eggs"
                            ? this.feedbackLogin
                            : this.submitForm
                        }
                      >
                        <h2 style={textStyle}>SIGN IN </h2>
                        <p className="text-muted" style={textStyle}>
                          Sign In to your account
                        </p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-user"></i>
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="email"
                            placeholder="Username"
                            required
                            // autoComplete="username"
                            name="username"
                            value={this.state.username}
                            onChange={this.onChange}
                            style={{ fontFamily: "Times New Roman" }}
                          />
                        </InputGroup>
                        <InputGroup className="mb-4">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="icon-lock"></i>
                            </InputGroupText>
                          </InputGroupAddon>

                          <Input
                            // type="password"
                            type={this.state.passwordType}
                            placeholder="Password"
                            name="password"
                            //autoComplete="current-password"
                            value={this.state.password}
                            style={{ fontFamily: "Times New Roman" }}
                            onChange={this.onChange}
                          />
                          <br />
                          {/* { console.log(this.state.invalidPswrd)} */}
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              onClick={() => {
                                this.setState({
                                  passwordType:
                                    this.state.passwordType === "password"
                                      ? "text"
                                      : "password",
                                });
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {this.state.passwordType === "password" ? (
                                <i className="fa fa-eye-slash"></i>
                              ) : (
                                <i className="fa fa-eye"></i>
                              )}
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        <Row style={{ marginTop: "-24px", marginLeft: "1px" }}>
                          {(this.state.isErrorCheck || this.state.invalidPswrd) && (
                            <span style={{ color: "tomato" }}>
                              {this.state.isErrorCheck ? this.state.responseErrorMsg : "Invalid password!"}
                            </span>
                          )}
                          {this.state.userStatus && (
                            <span style={{ color: "tomato" }}>
                              User is Deactivate !
                            </span>
                          )}
                        </Row>
                        <Row style={{ marginTop: "17px" }}>
                          <Col xs="6" className="center">
                            <Button
                              type="submit"
                              color="success"
                              className="px-4 rounded-pill  "
                              tabIndex={-1}
                              outline
                            >
                              Login
                            </Button>
                            <p id="signUpText">
                              Don't have an account?
                              <Link to="/SignUp">
                                <Button
                                  style={textStyle}
                                  color="link"
                                  onClick={() => {
                                    this.selectCompany();
                                  }}
                                >
                                  Sign Up
                                </Button>
                              </Link>
                            </p>
                          </Col>

                          <Col xs="6" className="text-right">
                            <Button
                              style={textStyle}
                              color="link"
                              className="px-0"
                              onClick={() => this.addToggle()}
                            >
                              Forgot password?
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col style={{ padding: "20px" }}>
                            {this.state.postingError ? (
                              <p style={{ color: "red" }}>
                                {this.state.postingErrorMsg}
                              </p>
                            ) : (
                              <p></p>
                            )}
                          </Col>
                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </CardGroup>
              </Col>
            </Row>
            <Modal
              show={this.state.showForgetModal}
              size="md"
              onHide={this.addToggle}
              backdrop="static"
            >
              <Modal.Header
                className="bg-white border-bottom-0 pb-0 ml-4"
                closeButton
                id="modalHeader"
              >
                <div className="text-left ">
                  <h3>Reset your password</h3>
                  <p className="text-muted">
                    Send reset instructions to your email address.
                  </p>
                </div>
              </Modal.Header>

              <Modal.Body>
                <div>
                  <div className="px-4 ml-1 pb-4">
                    <div className="">
                      <Form onSubmit={this.submitEmail}>
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="enterEmail"
                          required
                          name="enterEmail"
                          onChange={this.handleChange}
                        />
                        <span className="text-danger float-right">
                          {this.state.incorrectEmail &&
                            "User doesn't exist with this Email"}
                        </span>
                        <button
                          type="submit"
                          disabled={loader}
                          className="btn btn-outline-success rounded-pill mt-4 "
                        >
                          RESET PASSWORD
                        </button>
                      </Form>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              backdrop="static"
              show={this.state.showPasswordModal}
              size="md"
              onHide={this.toggleNewPaswrd}
            >
              <Modal.Header
                className="bg-white border-bottom-0 pb-0 ml-4"
                closeButton
                id="modalHeader"
              >
                <div className="text-left pl-3 ">
                  <h4 className="">Enter Your New Password</h4>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <div className="row rowStyle">
                    <div className="col-md-12 px-5">
                      <Form onSubmit={this.submitNewPassword}>
                        <label>New Password</label>
                        <InputGroup className="mb-4">
                          <Input
                            type={this.state.newPasswordType}
                            className="form-control"
                            id="newPassword"
                            required
                            name="newPassword"
                            onChange={this.handleChange}
                          />
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              onClick={() => {
                                this.setState({
                                  newPasswordType:
                                    this.state.newPasswordType === "password"
                                      ? "text"
                                      : "password",
                                });
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {this.state.newPasswordType === "password" ? (
                                <i className="fa fa-eye-slash"></i>
                              ) : (
                                <i className="fa fa-eye"></i>
                              )}
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        <label>Confirm Password</label>
                        <InputGroup className="mb-4">
                          <Input
                            type={this.state.confirmPasswordType}
                            required
                            className="form-control"
                            id="confirmPassword"
                            name="confirmPassword"
                            onChange={this.handleChangeConfirmPassword}
                          />
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText
                              onClick={() => {
                                this.setState({
                                  confirmPasswordType:
                                    this.state.confirmPasswordType ===
                                      "password"
                                      ? "text"
                                      : "password",
                                });
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {this.state.confirmPasswordType === "password" ? (
                                <i className="fa fa-eye-slash"></i>
                              ) : (
                                <i className="fa fa-eye"></i>
                              )}
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                        <span className="float-right text-danger">
                          {this.state.passwordError}
                        </span>

                        <button
                          disabled={this.state.disabled}
                          type="submit"
                          className="btn btn-outline-success rounded-pill mt-4 w-25 "
                        >
                          Save
                        </button>
                      </Form>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <Modal
              show={this.state.showModal}
              size="ml"
              onHide={this.state.showModal}
              backdrop="static"
              scrollable={true}
            >
              <Modal.Header
                className="Creative-Invoice-header-styling p-3"
                loseButton
                id="modalHeader"
              >
                <Modal.Title style={{ margin: "auto" }}>
                  <h5>SELECT YOUR COMPANY</h5>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body id="Modal_overflow">
                {this.state.isLoaderResponse
                  ? this.state.companyData.map((itm, index2) => {
                    return (
                      <div>
                        <div className="row rowStyle  ">
                          <div className="col-md-3"></div>
                          <div
                            className="col-md-6"
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <a
                              href
                              id="selectCompany"
                              onClick={() => {
                                this.selectCompany(
                                  itm[`COMPANY_ID`],
                                  itm[`COMPANY_DESC`],
                                  itm[`COMPANY_SYMBOL`],
                                  itm[`currency_id`],
                                  itm[`CURRENCY_SYMBOL`],
                                  itm[`COMPANY_DATE`],
                                  itm[`dep_method`],
                                  itm[`ye_mo`],
                                  itm[`comp_lang`]
                                );
                              }}
                            >
                              <img
                                className="shadow"
                                style={{
                                  width: "55px",
                                  height: "55px",
                                  borderRadius: "22%",
                                }}
                                // src={ `./../../../../../node_backendAS/uploads/CompanyLogo/ ${itm.COMPANY_SYMBOL}`}
                                // src={"./../../../../../node_backendAS/uploads/CompanyLogo/"}
                                src={this.GetCompanyLogo(itm.COMPANY_SYMBOL)}
                                alt="Default"
                              />
                              <p className="companyName">
                                {itm.COMPANY_DESC}
                              </p>
                            </a>
                          </div>
                          <div className="col-md-3"></div>
                        </div>
                        <hr
                          style={{
                            borderTop: "1px solid rgb(221, 221, 221)",
                            width: "496px",
                            /* margin-top: -5px; */
                            position: "relative",
                            left: "-15px",
                          }}
                        />
                      </div>
                    );
                  })
                  : ""}
                <span>
                  <Button
                    style={{ margin: "auto", display: "block" }}
                    type="submit"
                    size="md"
                    color="primary"
                    onClick={() => this.addToggleCompany()}
                  >
                    Add New Company
                  </Button>
                </span>
              </Modal.Body>
            </Modal>

            <Modal
              show={this.state.showCodeModal}
              size="ml"
              onHide={this.toggleCode}
              backdrop="static"
            >
              <Modal.Header
                className="bg-white border-bottom-0 pb-0 ml-5"
                closeButton
              >
                <div className="text-left">
                  <h3>Verification</h3>
                  <p className="text-muted">Enter Your Verification Code</p>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="px-5  pb-2">
                  <Form onSubmit={this.submitCodeForm}>
                    <span className="text-danger float-right">
                      {this.state.spanError}
                    </span>

                    <Label>Enter Code</Label>
                    <Input
                      className="form-control"
                      id="code"
                      name="code"
                      value={this.state.code}
                      onChange={this.onChange}
                      required
                    ></Input>

                    <Button
                      type="submit"
                      color="primary"
                      className="px-4 rounded-pill mt-4 "
                      outline
                    >
                      Verify
                    </Button>
                    <p id="signUpText" className="float-right">
                      <Link to="/SignUp">
                        <Button
                          className="text-decoration-none"
                          color="link"
                          onClick={this.resendCode}
                        >
                          Resend Code
                        </Button>
                      </Link>
                    </p>
                  </Form>
                </div>
              </Modal.Body>
            </Modal>
          </Container>
        </div>
        {showChangePasswordModal && (
          <UserChangePassword
            toggle={this.passwordModalToggle}
            userEmail={this.state.userEmail}
            callback={() => this.appUserLoginWithCompanyId(loginData)}
          />
        )}
        {this.state.showModalCompany && (
          <CompanyAdd toggle={this.toggleAddNew} user={this.state.user} />
        )}
      </>
    );
  }
}
export default Login;